module.exports = __webpack_public_path__ + "media/images/indicators/mananciais-b520deeb40abb006142ae504bb7fc5cd.png";